module.exports = __webpack_public_path__ + "img/icon-inventaire_hover.f44a19b8.svg";